import React from 'react';

import Header from '../../components/elements/Header';
import { IBasicLayoutProps } from '../config';

import { MainContainer, MainContentWrapper } from './styles';

function MainLayout({ children }: IBasicLayoutProps) {
  return (
    <MainContainer>
      <Header />
      <MainContentWrapper>{children}</MainContentWrapper>
    </MainContainer>
  );
}

export default MainLayout;
